var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar'),_c('div',{staticClass:"container"},[_c('keep-alive',{attrs:{"include":"Index"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }